import service from '@/services/superaccess'
import Holidays from 'date-holidays'

const holiday = {
  state: {
    holiday_modal: false,
    new_event: false
  },
  mutations: {
    setModalHolidayStatus (state, status) {
      state.holiday_modal = status
    },
    setNewEvent (state, status) {
      state.new_event = status
    },
    setHolidays (state, holidays) {
      state.holidays = holidays
      localStorage.setItem('holidays', holidays)
    }
  },
  getters: {
    getStatusHolidayModal (context) {
      return context.holiday_modal
    },
    getStatusNewEvent (context) {
      return context.new_event
    }
  },
  actions: {
    changeModalHolidayStatus (context, payload) {
      context.commit('setModalHolidayStatus', payload)
    },
    changeNewEventStatus (context, payload) {
      context.commit('setNewEvent', payload)
    },
    retrieveHolidays (context, payload) {
      return service.get('/api/holidays/', context)
    },
    syncHolidays (context, payload) {
      const hd = new Holidays(payload.country_code.toUpperCase())
      hd.setLanguages(payload.language)
      let holidays = hd.getHolidays((new Date()).getFullYear())
      return service.post('/api/sync-holidays', context, { data: holidays })
    },
    changeStatusHoliday (context, payload) {
      return service.put('/api/holiday/change', context, { holiday: payload })
    },
    createHoliday (context, payload) {
      return service.post('/api/holiday/create', context, { holiday: payload })
    }
  }
}

export default holiday



// WEBPACK FOOTER //
// app/javascript/src/store/holiday.js